import React from 'react';
import flectionNumeral from 'helpers/number';
import Stars from 'atomic/utilization/stars';
import OpinionsInterface from 'interfaces/opinions.interface';
import Link from '../link';

import './rating.scss';

interface OpinionsProps {
    className?: string;
    opinions: OpinionsInterface | null;
}

const Rating: React.FC<OpinionsProps> = props => (
    props.opinions && (
        <div className="rating">
            {
                props.opinions.count > 0
                && (
                    <span className="rating__title">
                        Ocena
                    </span>
                )
            }
            <Link href="#opinie" className="rating__container">
                {props.opinions.count > 0
                    ? (
                        <>
                            <Stars className={props.className} width={props.opinions.average}/>
                            {` od ${flectionNumeral(props.opinions.count, ['klienta', 'klientów', 'klientów'])} `}
                        </>
                    )
                    : 'Oceń produkt jako pierwszy'}
            </Link>
        </div>
    )
);

export default Rating;
